import React from 'react';
import InitialAssessmentView from '../InitialAssessment/InitialAssessmentView';

const NurseAssessmentView = () => {
    return (
        <InitialAssessmentView isNurse = {true}/>
    );
};
export default NurseAssessmentView;
